'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaRssSquare = function FaRssSquare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm14.4 28.6q0-1.2-0.8-2t-2-0.9-2 0.9-0.9 2 0.9 2 2 0.8 2-0.8 0.8-2z m7.9 2.1q-0.3-5.2-4-8.9t-8.8-3.9q-0.3 0-0.6 0.2t-0.2 0.5v2.9q0 0.2 0.2 0.4t0.5 0.3q3.4 0.2 5.9 2.7t2.7 5.9q0 0.2 0.2 0.4t0.5 0.2h2.8q0.3 0 0.6-0.2t0.2-0.5z m8.5 0q-0.1-3.4-1.2-6.6t-3.1-5.9-4.6-4.5-5.8-3.1-6.6-1.3q-0.4 0-0.6 0.2-0.2 0.2-0.2 0.5v2.9q0 0.3 0.2 0.5t0.5 0.2q4.6 0.2 8.4 2.5t6.3 6.2 2.5 8.4q0 0.3 0.2 0.5t0.5 0.2h2.8q0.3 0 0.5-0.2 0.3-0.2 0.2-0.5z m6.5-21.4v21.4q0 2.7-1.9 4.6t-4.5 1.8h-21.5q-2.6 0-4.5-1.8t-1.9-4.6v-21.4q0-2.7 1.9-4.6t4.5-1.8h21.5q2.6 0 4.5 1.8t1.9 4.6z' })
        )
    );
};

exports.default = FaRssSquare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/rss-square.js
// module id = 1459
// module chunks = 0